import _extends from '@babel/runtime/helpers/esm/extends';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';

var Repeat =
/*#__PURE__*/
function () {
  function Repeat(options) {
    var _this = this;

    this._intervalTimeoutId = null;
    this._counter = 0;

    this.start = function () {
      if (!_this._intervalTimeoutId) {
        _this._doAction({
          firstTime: true
        });

        return true;
      }

      return false;
    };

    this.stop = function () {
      if (_this._intervalTimeoutId) {
        clearTimeout(_this._intervalTimeoutId);
        _this._intervalTimeoutId = null;
        _this._counter = 0;
        return true;
      }

      return false;
    };

    this.pause = function () {
      if (_this._intervalTimeoutId) {
        clearTimeout(_this._intervalTimeoutId);
        _this._intervalTimeoutId = null;
        return true;
      }

      return false;
    };

    this.resume = function () {
      if (!_this._intervalTimeoutId) {
        _this._doAction();

        return true;
      }

      return false;
    };

    this._doAction =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(_temp) {
        var _ref2, firstTime, action, delay;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = _temp === void 0 ? {} : _temp, firstTime = _ref2.firstTime;

                if (_this._intervalTimeoutId) {
                  clearTimeout(_this._intervalTimeoutId);
                  _this._intervalTimeoutId = null;
                }

                if (!(!firstTime || firstTime && !_this.options.skipFirst)) {
                  _context.next = 6;
                  break;
                }

                action = _this.options.action;
                _context.next = 6;
                return action(_this._counter);

              case 6:
                _this._counter += 1;

                if (!(_this.options.times && _this._counter >= _this.options.times)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                delay = firstTime ? _this.options.firstTimeDelay : _this.options.delay;

                if (_this.options.getDelay) {
                  delay = _this.options.getDelay(_this._counter, _this.options);
                }

                _this._intervalTimeoutId = setTimeout(function () {
                  return _this._doAction();
                }, delay);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    this._validateOptions(options);

    this.options = _extends({}, options);
    this.options.firstTimeDelay = this.options.firstTimeDelay !== undefined ? this.options.firstTimeDelay : this.options.delay;
  }

  var _proto = Repeat.prototype;
  /**
   * Validate options
   * @param options
   * @private
   */

  _proto._validateOptions = function _validateOptions(options) {
    if (!options) {
      throw new Error('Options are required!');
    }

    if (!options.action) {
      throw new Error('Options action is required!');
    }

    if (!options.delay && options.delay !== 0) {
      throw new Error('Options delay is required!');
    }
  }
  /**
   * Start repeat actions
   * @returns {boolean}
   */
  ;
  /**
   * Update delay value
   * @param newDelay
   */


  _proto.updateDelay = function updateDelay(newDelay) {
    this.options.delay = newDelay;
  }
  /**
   * Interval action runner
   * @param firstTime
   * @returns {Promise<void>}
   */
  ;

  return Repeat;
}();

var makeRepeatObj = function makeRepeatObj(options) {
  return new Repeat(options);
};

export default makeRepeatObj;